// VIVA-910: cuando un visitante sin sesión intenta participar en un evento
// público, hay que devolverlo a ese evento una vez que se autentica.
//
// El destino se guarda en `sessionStorage` y no en el `state` del router porque
// la cadena de autenticación puede pasar por el alta de perfil, por un popup de
// Firebase o por una recarga completa de la página, y en cualquiera de esos
// saltos el state del router se pierde. `sessionStorage` muere con la pestaña,
// así que tampoco deja un destino viejo esperando en la siguiente visita.

const POST_AUTH_REDIRECT_KEY = "postAuthRedirect";

// Solo se aceptan rutas internas. Un valor manipulado no debe poder sacar al
// usuario del sitio: se descartan las URLs absolutas y las de protocolo
// relativo (`//otro-dominio`).
const isInternalPath = (path) =>
  typeof path === "string" && /^\/(?!\/)/.test(path.trim());

export const setPostAuthRedirect = (path) => {
  try {
    if (!isInternalPath(path)) return;
    sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, path.trim());
  } catch (error) {
    console.error("Error al guardar el destino posterior al login:", error);
  }
};

// VIVA-910: lee el destino SIN borrarlo. Hace falta cuando el destino se usa para
// construir un enlace en el render: consumirlo ahi lo perderia en el primer
// repintado, antes de que la persona alcance a hacer clic.
export const peekPostAuthRedirect = () => {
  try {
    const stored = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
    return isInternalPath(stored) ? stored.trim() : null;
  } catch (error) {
    console.error("Error al leer el destino posterior al login:", error);
    return null;
  }
};

// Devuelve el destino guardado y lo borra: se usa una sola vez.
export const consumePostAuthRedirect = () => {
  try {
    const stored = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
    sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
    return isInternalPath(stored) ? stored.trim() : null;
  } catch (error) {
    console.error("Error al leer el destino posterior al login:", error);
    return null;
  }
};
